const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;

const anonymousSettings = () => ({
  api_base: 'https://api-iam.intercom.io',
  app_id: INTERCOM_APP_ID,
  hide_default_launcher: false,
});

export function bootAnonymousIntercom() {
  window.intercomSettings = anonymousSettings();

  const w = window;
  const ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    const d = document;
    const i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    function l() {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.rel = 'preconnect';
      s.id = 'intercom-script-id';
      s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
      const x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }
    if (d.readyState === 'complete') {
      l();
    } else if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
}

let identifiedUserId = null;

export function identifyIntercomUser(user) {
  if (!user?.id || identifiedUserId === user.id) return;

  identifiedUserId = user.id;
  window.Intercom?.('update', {
    hide_default_launcher: false,
    username: user.username,
    user_hash: user.user_hash,
    user_id: user.id,
    name: `${user.name} ${user.lastName}`,
    email: user.email,
    created_at: Math.floor(user.createdAt / 1000),
    signed_up_at: Math.floor(user.createdAt / 1000),
    bluejacketeer_id: user.id,
    sentry_link: `https://sentry.io/organizations/serfe-id/issues/?project=1400609&query=user.id%3A${user.id}&statsPeriod=14d`,
  });
}

function clearIntercomStorage() {
  const names = document.cookie
    .split(';')
    .map((c) => c.split('=')[0].trim())
    .filter((n) => n.startsWith('intercom-'));

  const { hostname } = window.location;
  const domains = [null, hostname];
  const parts = hostname.split('.');
  for (let i = 1; i < parts.length - 1; i += 1) {
    domains.push(`.${parts.slice(i).join('.')}`);
  }

  names.forEach((name) => {
    domains.forEach((domain) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${
        domain ? `; domain=${domain}` : ''
      }`;
    });
  });

  Object.keys(localStorage)
    .filter((k) => k.startsWith('intercom'))
    .forEach((k) => localStorage.removeItem(k));
}

export function resetIntercom() {
  identifiedUserId = null;
  window.Intercom?.('shutdown');
  clearIntercomStorage();

  if (typeof window.Intercom !== 'function') {
    bootAnonymousIntercom();
    return;
  }

  window.intercomSettings = anonymousSettings();
  window.Intercom('boot', window.intercomSettings);
}
